class FetchSubject {
	constructor(
		public readonly facilityId: number,
		public readonly subjectId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchSubject;
